import Tool from '../Tool';
import { makeWhiteboardToolHandler } from './helpers';

/**
 * Handler for WhiteboardAgent::CreateWireframeTool
 * Creates wireframes on the whiteboard
 */
const createWireframeToolHandler = makeWhiteboardToolHandler(
  (toolCall, assistedWhiteboard) => {
    assistedWhiteboard.ensureVersionSaved();

    if (toolCall.content?.data) {
      const { wireframe } = JSON.parse(toolCall.content.data) as any;

      assistedWhiteboard.actionAddGeneratedWireframe(wireframe);
    }
  }
);

Tool.register(
  'WhiteboardAgent::CreateWireframeTool',
  createWireframeToolHandler
);
